import { AppState } from 'services/types';
import { VirtualizedTableColumnKey } from 'services/virtualizedTable/types';
import createDeepEqualSelector from 'utils/reselect/typescript/createDeepEqualSelector';

import { OwnProps } from '.';
import { ASCENDING, DESCENDING } from '../../constants';
import { selectSortColumn, selectSortDirection } from '../../selectors';

const selectColumnKey = (
    _state: AppState,
    props: OwnProps
): VirtualizedTableColumnKey | undefined => props.columnKey;

const selectIsSorted = createDeepEqualSelector(
    [selectColumnKey, selectSortColumn],
    (columnKey, sortColumn) => columnKey === sortColumn
);

const makeSelectIsSorted = (): typeof selectIsSorted => selectIsSorted;

const selectIsAscending = createDeepEqualSelector(
    [selectIsSorted, selectSortDirection],
    (isSorted, sortDirection) => isSorted && sortDirection === ASCENDING
);

const makeSelectIsAscending = (): typeof selectIsAscending => selectIsAscending;

const selectIsDescending = createDeepEqualSelector(
    [selectIsSorted, selectSortDirection],
    (isSorted, sortDirection) => isSorted && sortDirection === DESCENDING
);

const makeSelectIsDescending = (): typeof selectIsDescending =>
    selectIsDescending;

export {
    selectIsSorted,
    makeSelectIsSorted,
    selectIsAscending,
    makeSelectIsAscending,
    selectIsDescending,
    makeSelectIsDescending
};
